module.exports = __webpack_public_path__ + "static/media/r225.42926c34.jpg";